var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`myrecipe-form-step col-12 max-width-5 gridbox-element ${_vm.activeStep == _vm.stepNumber ? 'active' : ''}`},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }